//@flow
import React from 'react';

import {makeStyles, ButtonBase} from '@material-ui/core';
import {ArchiveOutlined} from '@material-ui/icons';

import {colors} from '../../../../../../../../../assets/styles/colors';
import {useCurrentConversation} from '../../../../../../utils/conversation';
import {useConversationMessages} from '../../../../../../utils/message';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '4.5rem',
    justifyContent: 'center',
    zIndex: 10,
  },
  label: {
    paddingInline: '.5rem',
    fontWeight: 600,
  },
  description: {
    paddingInline: '.5rem',
    fontSize: '0.8rem',
    color: colors.grey600,
    textAlign: 'left',
  },
  descriptionLink: {
    color: colors.grey700,
    fontWeight: 600,
  },
  notificationButton: {
    padding: '.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s ease-in-out, boxShadow 0.2s ease-in-out',
    background: `white`,
    color: colors.grey700,
    borderRadius: '1rem',
    // width: '50%',
  },
  notificationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'fit-content',
  },
  icon: {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.35rem',
  },
  closeButton: {
    width: '20px',
    height: '20px',
    color: 'white',
    background: colors.danger,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

type Props = {
  handleHiddenButton: () => void,
};

export default function ArchivedMessageNotification(props: Props) {
  const {handleHiddenButton} = props;
  const classes = useStyles();

  const {currentConversation} = useCurrentConversation();

  const {addPageArchivedChat} = useConversationMessages(
    currentConversation?.previousConversationId || '',
    false
  );

  const handleAddMessagesArchive = () => {
    if (!currentConversation?.previousConversationId) return;
    addPageArchivedChat(currentConversation.previousConversationId, '', true);
    handleHiddenButton();
  };

  return (
    <div className={classes.root}>
      <ButtonBase
        onClick={handleAddMessagesArchive}
        className={classes.notificationButton}
      >
        <ArchiveOutlined />
        <div className={classes.notificationHeader}>
          <span className={classes.label}>Conversación archivada</span>
        </div>
      </ButtonBase>
    </div>
  );
}
